import type { ComponentProps } from 'react';

import { OnboardingStepLayout } from '@sorare/gameplay/src/components/onboarding/OnboardingStepLayout';
import { useEnsureProUnlocked } from '@sorare/gameplay/src/hooks/onboarding/useEnsureProUnlocked';

export const MarketGuidanceLayout = (
  props: ComponentProps<typeof OnboardingStepLayout>
) => {
  useEnsureProUnlocked();
  return <OnboardingStepLayout {...props} />;
};
